import Vue from "vue";
import Swal from "sweetalert2";
import ApiClient from "./openapi/src/ApiClient";
import store from "./store";
import moment from "moment";
import config from "./config";

// we customize ApiClient with some customizations
ApiClient.instance.basePath = config.api.basePath;
ApiClient.instance.authentications = {
  "bearer-token": {
    type: "bearer",
    accessToken: function() {
      return Vue.prototype.$keycloak.token;
    }
  }
};
ApiClient.parseDate = function(str) {
  if (isNaN(str)) {
    return moment(str).format("YYYY-MM-DD");
  }
  return new Date(+str);
};

const clearStoreExceptions = {
  // eslint-disable-next-line
    exceptions: [
    "/initial-price/\\d+/get",
    "/initial-price/\\d+/save",
    "/target-occupancy/\\d+/compute",
    "/target-occupancy/\\d+/save",
    "/channel-integration/\\d+/*"
  ],
  match(url) {
    return this.exceptions.some(exp => new RegExp(exp).test(url));
  }
};

let ResponsesInterceptor = require("superagent-intercept")((err, res) => {
  if (res.status > 300) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!"
    });
  }
  // in case of succeed and request was a non GET operation, we will clear our
  // api responses cache to force to get fresh values
  //
  // we have some exception like compute action which generates a table, since we
  // don't want to lose our SelectionWidget data
  else if (
    res.req.method != "GET" &&
    !clearStoreExceptions.match(res.req.url)
  ) {
    store.commit("refresh");
  }
});

ApiClient.instance.plugins = [ResponsesInterceptor];

export default ApiClient.instance;
